/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import moment from 'utils/moment';
import {
  clearState,
  getAvpDefaultFields,
  fetchspecificAvpLogs,
  initiateAvpApplication,
  getAvpCategories,
  initiateDraftAvp,
  clearDraftState, deleteSaveAsDraftAvpLog
} from '../../redux/action';
import styles from './form.module.scss';
import Loading from '../../../../components/loading';
import Button from '../../../../components/button/button';
import HeaderBack from '../../../../components/headerBack';
import { GetFileName, S3Uploads } from '../../../services';
import Collapsible from '../../../../components/collapsible/Collapsible';
import CustomFields from '../../../../components/customFields/CustomFields';
import DeleteConfirmation from '../../../../components/deleteConfirmation/deleteConfirmation';
import { filterCustomFieldAnswers, getTitles, normalizeAttachments, handleSignature,
  getAnswerUpdates, isEmptyValue, validateFieldErrors, customSort } from '../../components/PermitData';
import ReqAttachments from '../../ADP/Components/ReqAttachments';
import { SaveAlert } from '../../components/ActionCompo';
import FormattedMessageWithClass from '../../../../components/formattedMessageWithClass';
import { PERMIT_ALREADY_RENEWED } from '../../constant';


// reusable component for Length, Width, Height fields
const DimensionInput = ({ label, value, onChange }) => (
  <div className={styles.lengthInputChildContainer}>
    <label htmlFor="dimension" style={{ margin: 0 }}>{label}</label>
    <input
      type="number"
      className={styles.dimensionInput}
      onChange={onChange}
      value={value}
    />
    <label htmlFor="dimension" style={{ margin: 0 }}>Meters</label>
  </div>
);

const AvpRenewal = (props) => {
  const { match: { params: { id } }, history } = props;

  const dispatch = useDispatch();
  const defaultFields = useSelector(states => states?.permitManagement?.avpDefaultFields);
  const customFields = useSelector(states => states?.permitManagement?.avpCustomFields);
  const permitDetails = useSelector(states => states?.permitManagement?.avpSpecificLog) || {};
  const avpCSchema = useSelector(states => states?.permitManagement?.avpCSchema);
  const oldCustomFields = permitDetails?.status === 14 ? customFields : avpCSchema;
  const avpCategoryList = useSelector(states => states?.permitManagement?.avpCategoryList);
  const loader = useSelector(states => states?.permitManagement?.avpInitiationStatus);
  const ordering = useSelector(states => states?.permitManagement?.avpOrdering);
  const reqAttach = useSelector(state => state.permitManagement?.avpReqAttachments);
  const notes = useSelector(states => states?.permitManagement?.avpNotes);
  const dataStatus = useSelector(s => s?.permitManagement?.getAvpDetailStatus);
  const avpDraftStatus = useSelector(states => states?.permitManagement?.avpDraftStatus);
  const renewalFields = useSelector(states => states?.permitManagement?.avpRenewalFields?.fields || []);
  const errorResponse = useSelector(states => states.permitManagement?.errorResponse);
  const actionDeleteDraftApplication = useSelector(states => states?.permitManagement?.actionDeleteDraftAVPApplication);
  const adminFields = permitDetails?.schema?.admin_fields.fields || [];

  const [isAlreadySubmited, setIsAlreadySubmited] = useState(false);
  const [allFields, setAllFields] = useState([]);
  const [mergedFields, setMergedFields] = useState([]);
  const [conditionalFields, setConditionalFields] = useState({});
  const [reqErrors, setReqErrors] = useState({});
  const [errors, setErrors] = useState({});
  const [renewalErrors, setRenewalErrors] = useState({});
  const [initial, setInitial] = useState({
    init: true,
    render1: false,
    render2: false,
    render3: false,
    render4: false
  });

  const [state, setState] = useState({
    answers: {},
    preAnswers: {},
    loader: false,
    dateError: false,
    formErrors: false
  });

  const [alert, setAlert] = useState(false);
  const [load, setLoad] = useState(false);
  const [haveDimensionFields, setHaveDimensionFields] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);

  // fixed fields - Attachments and Signature
  const staticFields = [
    {
      conditional: false,
      default: false,
      description: '',
      enable_ocr: false,
      full_width: true,
      id: 'attachments',
      internal: true,
      list_view: false,
      lock: false,
      required: true,
      search_enable: false,
      source_fields: [],
      system_generated: false,
      title: 'Attachments',
      type: 'attachments'
    },
    {
      conditional: false,
      default: false,
      description: '',
      enable_ocr: false,
      full_width: true,
      id: 'signature',
      internal: true,
      list_view: false,
      lock: false,
      required: true,
      search_enable: false,
      source_fields: [],
      system_generated: false,
      title: 'Signature',
      type: 'signature'
    }
  ];

  // used for differentiate the default and custom fields
  const defaultIDs = [
    'first_name', 'last_name', 'phone', 'email', 'purpose_of_vehicle', 'year_of_reg',
    'category_of_veh_equp', 'vrea', 'insurance_validity', 'veh_powered_by',
    'tpaa', 'type_of_veh_equp', 'tpao', 'reg_no_veh_eqpt', 'pc_validity',
    'type_of_issue', 'employee_id', 'make_type', 'veh_insurance_company',
    'location_of_parking', 'category_of_avp', 'designation', 'signature',
    'length', 'height', 'width', 'company_address'
  ];

  const initialRender = () => {
    if (initial.init) {
      dispatch(fetchspecificAvpLogs(id));
      dispatch(getAvpDefaultFields());
      setInitial(prev => ({ ...prev, init: false }));
    }
  };
 useEffect(() => () => {
      // cleanup runs on unmount
      dispatch(clearState());
    }, [dispatch]);

  useEffect(() => {
    if (loader.error === true && errorResponse === PERMIT_ALREADY_RENEWED) {
      setIsAlreadySubmited(true);
      setState(prevState => ({ ...prevState, loader: false, dateError: '' }));
    }
  }, [errorResponse, loader]);

  useEffect(() => {
    if (actionDeleteDraftApplication?.success) {
      dispatch(clearDraftState());
      history.push('/avp/logs');
    }
    if (actionDeleteDraftApplication?.error) {
      setState({ ...state, loader: false });
    }
  }, [actionDeleteDraftApplication]);

  useEffect(() => {
    if (!renewalFields?.length) return;
    const newErrors = {};

    // ---------- helpers ----------
    const getValue = ids => state.answers?.renewal_response?.[ids];

    const isConditionMet = (field) => {
      if (!field.conditional) return true;
      const parentId = field.conditional_field?.key;
      const parentValue = getValue(parentId);
      if (parentValue === null) return false;
      if (Array.isArray(parentValue)) {
        return field.conditional_values?.some(cond => parentValue.includes(cond.value));
      }
      return field.conditional_values?.some(cond => cond.value === parentValue);
    };

    // ---------- renewal validation ----------
    renewalFields.forEach((field) => {
      const conditionMet = isConditionMet(field);
      if (!field.required || !conditionMet) {
        newErrors[field.id] = false;
        return;
      }
      const value = getValue(field.id);
      newErrors[field.id] = isEmptyValue(value, field.type);
    });

    // ---------- update renewal errors ----------
    setRenewalErrors(newErrors);
  }, [renewalFields, state.answers?.renewal_response]);

  useEffect(() => {
    if (permitDetails && Object.keys(permitDetails)?.length > 0) {
      const userDataFilterPrevPermit = {};
      Object.keys(permitDetails).forEach((key) => {
        if (key !== 'prev_permit') {
          userDataFilterPrevPermit[key] = permitDetails[key];
        }
      });
        setState(prev => ({ ...prev,
        preAnswers: userDataFilterPrevPermit
      }));
    }
  }, [permitDetails]);

  useEffect(() => {
    if (defaultFields && Object.keys(permitDetails)?.length > 0) {
      const fIds = defaultFields?.map(f => f.id);
      const hasLWH = ['length', 'width', 'height'].every(fId => fIds?.includes(fId));
      setHaveDimensionFields(hasLWH);
      const combinedFields = [...defaultFields, ...customFields];
      let Fields;
      let condFields = {};
      let fieldErros = { ...errors };
      const filteredFields = combinedFields?.filter(field => field?.id !== 'signature' && !field?.isDisabled);
      if (ordering?.length) { // sorted - if ordering
        Fields = ordering
          .map(orderId => filteredFields.find(field => field.id === orderId))
          .filter(field => field); // Remove undefined entries if any
      } else {
        Fields = filteredFields; // without sorted - if no ordering
      }
      setMergedFields(Fields);
      setInitial({ ...initial, render1: true });
      Fields.forEach((ele) => {
        if (ele.conditional) { // check the conditional fields
          if (condFields[ele.conditional_field.key]) {
            condFields[ele?.conditional_field?.key] = [...condFields[ele?.conditional_field?.key], ele];
          } else {
            condFields[ele?.conditional_field?.key] = [ele];
          }
        } else {
          fieldErros = { ...fieldErros, [ele.id]: ele.required };
          }
      });
      setConditionalFields(condFields);
      setErrors(fieldErros);
      setState(prev => ({ ...prev, loader: false }));
    } else {
      initialRender();
      setState(prev => ({ ...prev, loader: true }));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultFields, id, dispatch, permitDetails]);

  useEffect(() => {
    const setTypeOfIssue = () => {
      const all = mergedFields?.map((ele) => {
        if (ele.id === 'type_of_issue') {
          return {
            ...ele,
            values: [{
              key: 'Renewal',
              value: 'Renewal'
            }],
            disable: true,
            default_value: {
              key: 'Renewal',
              value: 'Renewal'
            }
          };
        }
        return ele;
      });
      setAllFields(all);
      setInitial({ ...initial, render1: false, render2: true });
    };
    if (mergedFields?.length > 0 && initial.render1) setTypeOfIssue();
  }, [mergedFields, initial]);

  useEffect(() => {
    dispatch(getAvpCategories());
  }, [dispatch]);

  useEffect(() => {
    const render = initial.render2 && allFields?.length > 0 && Object.keys(state.preAnswers || {})?.length > 0;
    if (!render) return;

    const updatedPreAnswers = { ...state.preAnswers };
    const selectFields = allFields.filter(f => f.type === 'select' && !f.isDisabled);
    const disableFields = defaultFields?.filter(f => defaultIDs.includes(f.id) && f.isDisabled);

    // Handle select fields with invalid answers
    if (selectFields?.length) {
      selectFields.forEach((field) => {
        const validValues = field.values?.map(v => v.value) || [];
        const isDefaultField = defaultIDs.includes(field.id);
        const answer = isDefaultField ? updatedPreAnswers[field.id] : updatedPreAnswers.response?.[field.id];

        if (!validValues.includes(answer)) {
          if (isDefaultField) {
            delete updatedPreAnswers[field.id];
          } else if (updatedPreAnswers.response?.[field.id]) {
            delete updatedPreAnswers.response[field.id];
          }
        }
      });
    }
    // Remove disabled fields
    if (disableFields?.length) disableFields.forEach(field => delete updatedPreAnswers[field.id]);

    // Update state
    setState(prev => ({
      ...prev,
      preAnswers: {
        ...updatedPreAnswers
      }
    }));
    setInitial(prev => ({ ...prev, render2: false, render3: true }));
  }, [initial.render2, defaultFields, allFields, state]);

  useEffect(() => {
    const render = async () => {
      const hasPreAnswers = Object.keys(state.preAnswers || {}).length > 0;

      if (!initial.render3 || !hasPreAnswers) return;

      if (state.preAnswers.tpaa === '0.00') delete state.preAnswers.tpaa;
      if (state.preAnswers.tpao === '0.00') delete state.preAnswers.tpao;
      ['schema', 'comment', 'signature', 'payment_options',
        'prefixes', 'violations', 'work_flow', 'comments_count']
        .forEach(e => delete state.preAnswers[e]);

      if (permitDetails?.status !== 14) {
        ['pc_validity', 'insurance_validity'].forEach(e => delete state.preAnswers[e]);
      }

      const filteredAnswers = await filterCustomFieldAnswers(oldCustomFields, customFields, permitDetails.response);

      setState(prev => ({
        ...prev,
        answers: {
          ...prev.answers,
          ...prev.preAnswers,
          use_prev_avp_no: false,
          response: filteredAnswers
        }
      }));

      setInitial(prev => ({ ...prev, render3: false, renderForAttachments: true }));
    };
    render();
  }, [initial, state]);

  useEffect(() => {
    const render = initial.renderForAttachments && reqAttach?.length > 0 && permitDetails?.status !== 14;
    if (!render) return;
    const all_attachments = (permitDetails?.attachments || [])
      .reduce((acc, obj) => ({ ...acc, [obj.attachment_id]: obj }), {});

    const requireAttachments = permitDetails?.req_attachments && Object.keys(permitDetails?.req_attachments || {}).reduce((acc, key) => {
      const mapped = permitDetails.req_attachments[key]
        .map(att => all_attachments[att])
        .filter(Boolean); // remove undefined items

      return { ...acc, [key]: mapped.length ? mapped : [] };
    }, {});

    setState(prev => ({
      ...prev,
      answers: {
        ...prev.answers,
        req_attachments: requireAttachments
      }
    }));

    setInitial(prev => ({ ...prev, renderForAttachments: false }));
  }, [initial, reqAttach]);

  useEffect(() => {
    if (permitDetails?.status === 14 && initial.renderForAttachments && Object.keys(state.preAnswers)?.length > 0) {
      const all_attachments = permitDetails?.attachments?.reduce((acc, obj) => ({ ...acc, [obj.attachment_id]: obj }), {});
      const requireAttachments = permitDetails?.req_attachments
        && Object.keys(permitDetails?.req_attachments)
        .reduce((acc, key) => ({ ...acc, [key]: permitDetails?.req_attachments[key].map(att => all_attachments[att]) }), {});
      const sign = permitDetails.signature;
      const isEmptySignature = (Array.isArray(sign) && sign.length === 0)
        || (Array.isArray(sign) && sign.length === 1 && Object.keys(sign[0]).length === 0);
      setState(prev => ({ ...prev,
        answers: {
          ...prev.preAnswers,
          ...prev.answers,
          req_attachments: { ...requireAttachments },
          signature: isEmptySignature ? null : permitDetails?.signature,
          attachments: permitDetails?.attachments
        } }));
      setInitial(prev => ({ ...prev, renderForAttachments: false }));
    }
  }, [state.preAnswers, initial.renderForAttachments, permitDetails]);

  useEffect(() => {
    let reqFieldError = {};
    if (reqAttach?.length > 0) {
      reqAttach.forEach((e) => {
        let name = e;
        if (typeof e === 'object') {
          name = e.attachmentName;
        }
        reqFieldError = {
          ...reqFieldError,
          [`${name}_attachments`]: (!state.answers?.req_attachments?.[`${name}_attachments`]?.length > 0)
        };
      });
      setReqErrors(reqFieldError);
    }
  }, [state.answers.req_attachments, reqAttach]);

  // Memoize newFieldErrors calculation outside of useEffect
  const newFieldErrors = useMemo(() => allFields
    .filter(fd => !fd.conditional && fd.type !== 'header' && fd.required)
    .reduce((acc, ele) => {
    let hasError;
    if (defaultIDs.includes(ele.id)) {
      hasError = !state.answers[ele.id];
    } else if (ele.type === 'attachments') {
      hasError = !state.answers?.response?.[ele.id]?.length > 0;
    } else {
      hasError = !state.answers?.response?.[ele.id];
    }
    return {
      ...acc,
      [ele.id]: hasError
    };
  }, {}), [state.answers, allFields]);

  useEffect(() => {
    setErrors((prevErrors) => {
      const hasChanges = Object.keys(newFieldErrors).some(
        key => newFieldErrors[key] !== prevErrors[key]
      );
      return hasChanges ? { ...prevErrors, ...newFieldErrors } : prevErrors;
    });
  }, [newFieldErrors]); // Note: Only depend on `newFieldErrors`

  useEffect(() => {
    if (loader?.success || avpDraftStatus?.success) {
      history.push('/avp/logs');
      dispatch(clearState());
      dispatch(clearDraftState());
    }
  }, [loader, history, dispatch, avpDraftStatus]);

  useEffect(() => () => {
    dispatch(clearState());
    dispatch(clearDraftState());
    setState(prev => ({ ...prev, answers: {}, preAnswers: {} }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRenewalFieldErrorChanged = (fieldId, value) => {
    setRenewalErrors(prevErr => ({ ...prevErr, [fieldId]: value }));
  };

  const handleRenewalAnswerChanged = (answer, fieldId) => {
    setState({ ...state, answers: { ...state.answers, renewal_response: { ...state.answers.renewal_response, [fieldId]: answer } } });
  };

  const getRenewalRequired = (fields) => {
    let requiredKeys = { ...renewalErrors };
    if (fields?.length !== 0) {
      fields.forEach((ele) => {
        // checking required fields
        if (ele.required) {
          requiredKeys = { ...requiredKeys, [ele.id]: !state.answers?.renewal_response?.[ele.id] };
        }
      });
    }
    return requiredKeys;
  };

  const handleAnswerChanged = (section, answer, fieldId) => {
    const { updates, errorUpdates } = getAnswerUpdates({
      section,
      answer,
      fieldId,
      allFields,
      conditionalFields,
      currentAnswers: state.answers,
      defaultIDs
    });

    // ---------- state update ----------
    setState(prev => ({
      ...prev,
      answers: {
        ...prev.answers,
        ...updates,
        response: {
          ...prev.answers.response,
          ...(updates.response || {})
        }
      }
    }));

    // ---------- error update ----------
    setErrors(prev => ({
      ...prev,
      ...errorUpdates
    }));
  };

  const handleConfirmDelete = () => {
    setConfirmDelete(true);
  };

  const toggleConfirmDelete = () => {
    setConfirmDelete(!confirmDelete);
  };

  const remove = () => {
    const logId = props?.match?.params?.id;
    setState({ ...state, loader: true });
    dispatch(deleteSaveAsDraftAvpLog(logId));
    setConfirmDelete(false);
  };

  const handleFieldErrorChanged = (fieldId, value) => {
    setErrors(prevErrors => ({ ...prevErrors, [fieldId]: value }));
  };

  const handleRemoveAttachments = (attachment) => {
    const filtereAttachments = state.answers?.attachments?.filter(e => e?.attachment_id !== attachment?.attachment_id);
    setState({ ...state, answers: { ...state.answers, attachments: filtereAttachments } });
  };


  const getRequired = (data, isFieldError) => {
    let requiredKeys = { // static fields for required
      attachments: !state.answers?.attachments?.length > 0,
      signature: !state.answers?.signature
    };
    if (!haveDimensionFields) {
      const { length, width, height } = state.answers;
      requiredKeys = { ...requiredKeys, length: !length, width: !width, height: !height };
    }
    let FieldError = { ...errors };
    if (data?.length !== 0) {
      data.forEach((ele) => {
        if (ele.required) { // checking required fields
          if (defaultIDs.includes(ele.id)) { // checking required default fields
            requiredKeys = { ...requiredKeys, [ele.id]: true };
            FieldError = { ...FieldError, [ele.id]: !state.answers[ele.id] };
          } else if (!(defaultIDs.includes(ele.id))) { // checking required fields
            requiredKeys = { ...requiredKeys, [ele.id]: true };
            FieldError = { ...FieldError, [ele.id]: !state.answers?.response?.[ele.id] };
          }
        }
      });
    }
    return isFieldError ? FieldError : requiredKeys;
  };

  const handleUploadAttachments = async (attachments, entity) => {
    const attachmentIds = [];
    const newAttachments = [];
    const oldAttachments = [];
    attachments.forEach((e) => {
      if (!e.id) {
        newAttachments.push(e);
      } else if (e.id) {
        oldAttachments.push(e.attachment_id);
      }
    });
    let fileIds = '';
    if (newAttachments.length > 0) {
      fileIds = await getFileNames(newAttachments?.length);
    }
    if (fileIds) {
      await doS3Upload(
        newAttachments,
        fileIds,
        entity || 'vehicle_permit',
        getErrorAlert
      ).then(() => {
        fileIds.filename.forEach((aid) => {
          attachmentIds.push(aid.toString());
        });
      });
    }
    if (oldAttachments.length > 0) {
      attachmentIds.push(...oldAttachments);
    }
    return attachmentIds;
  };

  const getFileNames = async (count) => {
    const response = await GetFileName.getPermitUploadFileName(count);
    return response;
  };

  const doS3Upload = async (files, fileIds, entity, getErrorAlert) => {
    const response = await S3Uploads.uploadFiles(
      files,
      fileIds.filename,
      entity,
      undefined,
      undefined,
      getErrorAlert
    );
    return response;
  };

  const uploadtoS3 = async (attachments) => {
    let fileIds = '';
    fileIds = await getFileNames(attachments.length);
    const list = [];
    if (fileIds) {
      await doS3Upload(attachments, fileIds, 'vehicle_permit', getErrorAlert)
        .then((res) => {
          res.forEach((ele) => {
            list.push(ele?.id?.toString());
          });
        });
    }
    return list;
  };

  const handelSubmit = async (isDraft) => {
    const { attachments, insurance_validity, pc_validity, signature, req_attachments } = state.answers;
    setIsAlreadySubmited(false);
    let selectedDataObj = {};
    let error = validateFieldErrors(state.answers, allFields, defaultIDs, handleFieldErrorChanged, haveDimensionFields);
    error = { ...error, attachments: !reqAttach?.length > 0 ? !state.answers.attachments?.length : false };
    const noErrors = Object.keys(error).every(k => (error[k] === false));
    const noReqErrors = Object.keys(reqErrors).every(k => reqErrors[k] === false);
    const noRenewalErrors = renewalFields ? Object.values(renewalErrors).every(value => value === false) : true;
    const pc_validity_check = allFields?.some(e => e.id === 'pc_validity' && e.isDisabled === false);
    const insurance_validity_check = allFields?.some(e => e.id === 'insurance_validity' && e.isDisabled === false);
    if (!isDraft && (pc_validity_check && pc_validity && moment(pc_validity).diff(moment(new Date())) < 0)) {
      setState(prevState => ({
        ...prevState,
        dateError: `${getTitles(allFields, 'pc_validity') || 'Pollution certificate validity Date'}
          should be a future date. Please modify the date and try again.`
      }));
    } else if (!isDraft && (insurance_validity_check && insurance_validity && moment(insurance_validity).diff(moment(new Date())) < 0)) {
      setState(prevState => ({
        ...prevState,
        dateError: `${getTitles(allFields, 'insurance_validity') || 'Insurance validity Date'}
          should be a future date. Please modify the date and try again.`
      }));
    } else if ((noErrors && noReqErrors && noRenewalErrors) || isDraft) {
      setState(prevState => ({ ...prevState, loader: true, dateError: '' }));

      const attchList = reqAttach?.length > 0 && Object.entries(req_attachments || {}).reduce((acc, [key, attachment]) => {
        if (Array.isArray(attachment)) {
          acc[key] = attachment
            .map(item => item?.attachment_id)
            .filter(aid => typeof aid === 'string');
        } else {
          acc[key] = [];
        }
        return acc;
      }, {});
      const attachmentId = (!reqAttach?.length > 0 && attachments?.length > 0)
        ? attachments.map(item => item?.attachment_id).filter(aid => typeof aid === 'string')
        : [];
      const signatureId = await handleSignature(signature, handleUploadAttachments, uploadtoS3, 'vehicle_permit');

      const customSignFields = allFields.filter(field => field.type === 'signature') || [];

      if (customSignFields.length > 0) {
        for (let index = 0; index < customSignFields.length; index++) {
          const customSignField = customSignFields[index]?.id;
          const schemaField = customSignFields[index];
          const customSignValue = Array.isArray(state.answers?.response?.[customSignField])
            ? state.answers?.response?.[customSignField]
            : !!state.answers?.response?.[customSignField] && [state.answers?.response?.[customSignField]];
          if (schemaField?.type === 'signature' && customSignValue?.length > 0) {
            // eslint-disable-next-line no-await-in-loop
            state.answers.response[customSignField] = await handleUploadAttachments(customSignValue, 'vehicle_permit') || [];
          }
        }
      }
      const multiselectFields = allFields.filter(schemaField => (schemaField?.type === 'multiselect'));
      if (multiselectFields.length > 0) {
        multiselectFields.forEach((field) => {
          const fieldId = field.id;
          if (Array.isArray(state.answers?.response?.[fieldId])) {
            state.answers.response[fieldId] = customSort(state.answers.response[fieldId]);
          }
        });
      }

      const normalizedResponse = {
        ...state.answers.response,
        ...normalizeAttachments(allFields, state.answers.response)
      };

      const normalizedAdminResponse = {
        ...state.answers.admin_response,
        ...normalizeAttachments(adminFields, state.answers.admin_response)
      };

      const normalizedRenewalResponse = {
        ...state.answers.renewal_response,
        ...normalizeAttachments(renewalFields, state.answers.renewal_response)
      };

        const avp_category_id = avpCategoryList?.find(ele => (ele.name === state.answers?.category_of_avp && ele?.id));

        let data = {
          ...state.answers,
          response: normalizedResponse,
          admin_response: normalizedAdminResponse,
          renewal_response: normalizedRenewalResponse,
          attachments: attachmentId,
          req_attachments: attchList,
          avp_category: avp_category_id?.id || null,
          signature: signatureId?.[0] || [],
          prev_permit: permitDetails?.id,
          prev_avp_no: state.answers?.avp_no,
          status: isDraft ? 'Draft' : null,
          type_of_issue: 'Renewal',
          year_of_reg: state?.answers?.year_of_reg ? moment(state?.answers?.year_of_reg).format('YYYY') : null,
          pc_validity: state?.answers?.pc_validity ? moment(state.answers.pc_validity).format('YYYY-MM-DD') : null,
          insurance_validity: state?.answers?.insurance_validity ? moment(state.answers.insurance_validity).format('YYYY-MM-DD') : null,
          ...selectedDataObj
        };
        if (data.phone) {
          data.phone = data.phone[0] + data.phone.slice(1).replace(/[^\d]/g, '');
        }
        if (reqAttach?.length > 0 && Object.keys(data.req_attachments)?.length > 0) {
          data.attachments.push(...Object.values(data.req_attachments).flat());
        }
        if (allFields.length !== 0) {
          let checkbox = allFields.filter(ele => ele.type === 'boolean');
          if (checkbox?.length!==0) {
            checkbox.forEach((ele) => {
              if (!data.response[ele.id]) {
                data={ ...data, response: { ...data.response, [ele.id]: false } };
              }
            });
          }
        }
        const { ...filteredData } = data;
        if (permitDetails?.status === 14) {
          dispatch(initiateDraftAvp(id, filteredData));
        } else {
          dispatch(initiateAvpApplication(filteredData));
        }
        setState(prevState => ({ ...prevState, formErrors: false, loader: false, dateError: '' }));
    } else {
      setState(prevState => ({ ...prevState, formErrors: true, dateError: '' }));
    }
  };

  const handleChange = dimension => (e) => { // for dimension field answers
    const value = e.target.value > 0 ? e.target.value : 0;
    setState(prevState => ({
      ...prevState,
      answers: {
        ...prevState.answers,
        [dimension]: value
      }
    }));
    handleFieldErrorChanged(dimension, e.target.value.length === 0);
  };

  const getAnswers = fieldId => ( // Helper function to get answers
    defaultIDs.includes(fieldId)
    ? state.answers[fieldId]
    : state.answers.response?.[fieldId]);

  let fieldAnswers = {}; // Build the answers object using a loop
  allFields.forEach((field) => {
    fieldAnswers[field.id] = getAnswers(field.id);
  });

  const getErrorAlert = value => setAlert(value);

  const getLoadingStatus = value => setLoad(value);

  const isEmpty = v => Number(v) === 0 || v === '';
  const { height, length, width } = state.answers;
  const hasEmptyFields = [height, length, width].some(isEmpty);

  return (
    <div>
      <Loading loadingStatus={state.loader || dataStatus?.loading || avpDraftStatus?.loading} />
      <HeaderBack
        translationID="workorder.settings.back"
        translationDefault="Back"
        backRoute={permitDetails?.status === 14 ? '/avp/logs' : `/avp/detail/${id}`
        }
      />
      <div className={styles.container}>
        {/* Header */}
        <div className={styles.headder}>
          <h4>
            <FormattedMessage id="avp.applications"
              defaultMessage="Initiate Application"
            />
          </h4>
        </div>
        <div style={{ padding: '10px' }}>
          {/* All Default and Custom fields from Schema  */}
          <CustomFields
            handleAnswerChanged={(a, b) => (handleAnswerChanged(defaultIDs.includes(b) ? 'answers': 'response', a, b))}
            handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
            handleAttachmentFailedAlert={getErrorAlert}
            handleAutoUploadAttachments={uploadtoS3}
            getLoadingStatus={getLoadingStatus}
            entityName="vehicle_permit"
            showFormErrors={state.formErrors}
            requiredMap={getRequired(allFields, true)}
            fields={allFields}
            answers={fieldAnswers}
            adp
            isSignatureUpload
            forQuestionMarkHelp
          />
          {!haveDimensionFields && (
            <>
              <small style={{ color: 'red' }}> * </small>
              <label htmlFor="dimension">
                <FormattedMessage id="avp.vehicle.dimension"
                  defaultMessage="Dimension Of Vehicle"
                />
              </label>
              {/* dimenesion fields - Length Width Height */}
              <div>
                <div className={styles.lengthinput}>
                  <DimensionInput
                    label="Length"
                    value={state.answers?.length}
                    onChange={handleChange('length')}
                    />
                  <DimensionInput
                    label="Width"
                    value={state.answers?.width}
                    onChange={handleChange('width')}
                    />
                  <DimensionInput
                    label="Height"
                    value={state.answers?.height}
                    onChange={handleChange('height')}
                    />
                </div>
                {state.formErrors && hasEmptyFields && (
                  <small style={{ color: 'red' }}>
                    <FormattedMessage
                      id="pulpoforms.errors.not_blank"
                      defaultMessage="This field cannot be empty"
                      />
                  </small>
                )}
              </div>
            </>
          )}
          {renewalFields?.length > 0 && (
            <CustomFields
              handleAnswerChanged={(a, b) => (handleRenewalAnswerChanged(a, b))}
              handleFieldErrorChanged={(a, b) => handleRenewalFieldErrorChanged(a, b)}
              showFormErrors={state.formErrors}
              requiredMap={getRenewalRequired(renewalFields)}
              handleAttachmentFailedAlert={getErrorAlert}
              handleAutoUploadAttachments={uploadtoS3}
              getLoadingStatus={getLoadingStatus}
              entityName="vehicle_permit"
              fields={renewalFields}
              answers={state.answers?.renewal_response || {}}
              adp
              forQuestionMarkHelp
            />
          )}
          {/* Notes */}
          <div>
            <Collapsible
              adp
              title="Note:"
              openOnMount={false}
              collapsibleHeight="0"
            >
              {notes?.length !== 0 && (
                <div style={{ height: 'auto' }}>
                  {notes?.map((ele, i) => <p>{`(${i + 1}) ${ele}`}</p>)}
                </div>
              )}
            </Collapsible>
          </div>
          {/* Static Default fields - Attachments and Signature */}
          {reqAttach?.length !== 0 && (
            <div>
              <Collapsible
                adp
                title="Required Attachments:"
                openOnMount={false}
                collapsibleHeight="0"
                overflowVisible
              >
                  <div style={{ height: 'auto' }}>
                    {reqAttach?.map((ele) => {
                      const { attachmentName } = ele;
                      return (
                        <ReqAttachments
                          {...staticFields[0]}
                          handleAnswerChanged={(a, b) => handleAnswerChanged(
                            'req_attachments', a, `${attachmentName}_${b}`
                          )}
                          attachments={state.answers?.req_attachments?.[`${attachmentName}_attachments`]}
                          showFieldErrors={state.formErrors}
                          handleAttachmentFailedAlert={getErrorAlert}
                          handleAutoUploadAttachments={uploadtoS3}
                          getLoadingStatus={getLoadingStatus}
                          entityName="vehicle_permit"
                          handleRemove={handleRemoveAttachments}
                          attachmentName={attachmentName}
                          dateDetails={ele}
                          adpAnswers={state.answers}
                          handleDateChange={(a, b) => handleAnswerChanged(
                            'req_attachments_dates', a, `${attachmentName}_${b}`
                          )}
                          handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
                        />
                      );
                    })}
                  </div>
              </Collapsible>
            </div>
          )}
          <div>
            <CustomFields
              fields={reqAttach?.length > 0
                ? staticFields.filter(field => field.id !== 'attachments')
                : staticFields}
              answers={state.answers}
              showFormErrors={state.formErrors}
              handleAttachmentFailedAlert={getErrorAlert}
              handleAutoUploadAttachments={uploadtoS3}
              getLoadingStatus={getLoadingStatus}
              handleRemove={handleRemoveAttachments}
              entityName="vehicle_permit"
              adpAttachments
              requiredMap={getRequired(staticFields)}
              handleAnswerChanged={(a, b) => handleAnswerChanged('answers', a, b)}
              handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
              isSignatureUpload
              forQuestionMarkHelp
            />
          </div>
          {!permitDetails?.settings?.hideSamePermit && (
            <label htmlFor="avp_number">
              <input
                type="checkbox"
                id="avp_number"
                style={{ margin: '0 5px' }}
                onChange={(e) => {
                  setState(prevState => ({ ...prevState,
                    answers: { ...state.answers, use_prev_avp_no: e.target.checked }
                  }));
                }}
                value={state.answers.use_prev_avp_no}
              />
                <FormattedMessage
                  id="permit.use_same_permit"
                  defaultMessage="Use Same Permit Number"
                />
            </label>
          )}
        </div>
        <div className={styles.submitButton} style={{ justifyContent: `${state.formErrors
          || isAlreadySubmited === true ? 'space-between': 'flex-end'}` }}>
          <p className={styles.errorMessage}>
            {state.dateError}
            {(!state.dateError && state.formErrors) && isAlreadySubmited === false &&(
              <FormattedMessageWithClass
                id=" "
                defaultMessage="* Please fill all the required fields"
                className={styles.errorMessage}
                tagName="p"
              />
            )}
          </p>
          {(isAlreadySubmited === true && !state.dateError) && (
              <FormattedMessageWithClass
                id=" "
                defaultMessage="A Renewal Application is Already In Progress. Please Cancel This."
                className={styles.errorMessage}
                tagName="p" />
            )}
          <div style={{ display: 'flex', gap: '16px' }}>
            {permitDetails && permitDetails?.status === 14 && (
              <Button
                action="danger"
                onClick={() => handleConfirmDelete()}
                translationID="assets.delete"
                defaultText="Delete"
              />
            )}
            <Button
              action="primary"
              onClick={() => (handelSubmit(true))}
              translationID="avp.save_as_draft"
              defaultText="Save as Draft"
              disabled={load}
            />
            <Button
              action="secondary"
              onClick={() => (handelSubmit(false))}
              translationID="avp.submit"
              defaultText="Submit"
              disabled={load}
            />
          </div>
        </div>
      </div>
      {alert && <SaveAlert alert={alert} setAlert={setAlert} handelSubmit={() => handelSubmit(true)} />}
      <DeleteConfirmation
        isActive={confirmDelete}
        onClose={() => toggleConfirmDelete()}
        confirmDelete={() => remove()}
      />
    </div>
  );
};

export default AvpRenewal;
